function getQuantityCalculation(listTitle: string, QuantityVal: any) {
    
    switch (listTitle) {
        case 'Energy Log':
            return (((parseFloat(QuantityVal) * 1000).toFixed(2)).toString())

        case 'Imported Soil Log':
            return (((parseFloat(QuantityVal) * 1.6).toFixed(2)).toString())
        case 'Spoil Tracking Log':
            return (((parseFloat(QuantityVal) * 1.6).toFixed(2)).toString())
        case 'Waste Tracking Log':
            return (((parseFloat(QuantityVal) * 0.3531466672).toFixed(2)).toString())

        case 'Wastewater Tracking Log':
            return (((parseFloat(QuantityVal) * 264.172).toFixed(2)).toString())
        case 'Water Log':
            return (((parseFloat(QuantityVal) * 264.172).toFixed(2)).toString())

        default: return null
    }
}

function getQuantityGallonToM3(listTitle: string, QuantityVal: any) {
    switch (listTitle) {
        case 'Energy Log':
            return (((parseFloat(QuantityVal) / 1000).toFixed(2)).toString())

        case 'Imported Soil Log':
            return (((parseFloat(QuantityVal) / 1.6).toFixed(2)).toString())
        case 'Spoil Tracking Log':
            return (((parseFloat(QuantityVal) / 1.6).toFixed(2)).toString())
        case 'Waste Tracking Log':
            return (((parseFloat(QuantityVal) / 0.3531466672).toFixed(2)).toString())

        case 'Wastewater Tracking Log':
            return (((parseFloat(QuantityVal) / 264.172).toFixed(2)).toString())
        case 'Water Log':
            return (((parseFloat(QuantityVal) / 264.172).toFixed(2)).toString())

        default: return null
    }
}
function getSoilTonneToM3(listTitle: string, QuantityVal: any) {
    switch (listTitle) {
        case 'Energy Log':
            return (((parseFloat(QuantityVal) / 1000).toFixed(2)).toString())

        case 'Imported Soil Log':
            return (((parseFloat(QuantityVal) / 1.6).toFixed(2)).toString())
        case 'Spoil Tracking Log':
            return (((parseFloat(QuantityVal) / 1.6).toFixed(2)).toString())
        case 'Waste Tracking Log':
            return (((parseFloat(QuantityVal) / 0.3531466672).toFixed(2)).toString())

        case 'Wastewater Tracking Log':
            return (((parseFloat(QuantityVal) / 264.172).toFixed(2)).toString())
        case 'Water Log':
            return (((parseFloat(QuantityVal) / 264.172).toFixed(2)).toString())

        default: return null
    }
}
function getEnergyLiterToM3(listTitle: string, QuantityVal: any) {
    switch (listTitle) {
        case 'Energy Log':
            return (((parseFloat(QuantityVal) / 1000).toFixed(2)).toString())

        case 'Imported Soil Log':
            return (((parseFloat(QuantityVal) / 1.6).toFixed(2)).toString())
        case 'Spoil Tracking Log':
            return (((parseFloat(QuantityVal) / 1.6).toFixed(2)).toString())
        case 'Waste Tracking Log':
            return (((parseFloat(QuantityVal) / 0.3531466672).toFixed(2)).toString())

        case 'Wastewater Tracking Log':
            return (((parseFloat(QuantityVal) / 264.172).toFixed(2)).toString())
        case 'Water Log':
            return (((parseFloat(QuantityVal) / 264.172).toFixed(2)).toString())

        default: return null
    }
}


export {getQuantityCalculation, getQuantityGallonToM3, getSoilTonneToM3, getEnergyLiterToM3};